module.exports = __webpack_public_path__ + "static/media/cynthia-icon.7b370ed8.png";